//material ui
import React, { useContext } from "react";
import { useTheme } from "@mui/styles";
import { Typography, Box, useMediaQuery } from "@mui/material";

//json2mq
import json2mq from "json2mq";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";
import { ColorContext } from "../../pages/Bootcamp";

const CardBenefitsDesktop = () => {
  const md = useMediaQuery(
    json2mq({
      maxWidth: 1200,
      minWidth: 900,
    })
  );
  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1535,
      minWidth: 1201,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
    })
  );

  const stylesHelper = () => {
    if (md) {
      return {
        firstImg: {
          height: "50px",
          width: "50px",
          color: theme.palette.green.main,
          marginTop: "25px",
        },
        secondImg: {
          height: "50px",
          width: "50px",
          color: theme.palette.green.main,
          marginTop: "25px",
        },
        thirdImg: {
          height: "50px",
          width: "50px",
          color: theme.palette.green.main,
          marginTop: "25px",
        },
      };
    } else if (lg) {
      return {
        firstImg: {
          height: "60px",
          width: "52px",
          color: theme.palette.green.main,
          marginTop: "30px",
        },
        secondImg: {
          height: "60px",
          width: "52px",
          color: theme.palette.green.main,
          marginTop: "30px",
        },
        thirdImg: {
          height: "60px",
          width: "52px",
          color: theme.palette.green.main,
          marginTop: "30px",
        },
      };
    } else if (xl) {
      return {
        firstImg: {
          height: "72.6px",
          width: "65px",
          color: theme.palette.green.main,
          marginTop: "55px",
        },
        secondImg: {
          height: "72.6px",
          width: "65px",
          color: theme.palette.green.main,
          marginTop: "55px",
        },
        thirdImg: {
          height: "72.6px",
          width: "65px",
          color: theme.palette.green.main,
          marginTop: "55px",
        },
      };
    }
  };

  const { mainColor, secondaryColor } = useContext(ColorContext);

  const useStyles = (theme) => ({
    container: {
      display: "flex",
      flexDirection: { xs: "column" },
      alignItems: { xs: "center" },
      backgroundImage: `linear-gradient(to bottom, ${mainColor}12 0%, ${secondaryColor}03 100%);`,
      backgroundPosition: { xs: "center" },
      backgroundRepeat: "no-repeat",
      backgroundSize: "100% 140px",
      width: { xs: "100%" },
    },
    child: {
      display: "flex",
    },
    firstCard: {
      display: "flex",
      flexDirection: { xs: "column" },
      alignItems: { xs: "center" },
      background: "linear-gradient(to bottom, #23213f 0%, #03183d 100%)",
      height: { md: "300px", lg: "360px", xl: "454px" },
      width: { md: "270px", lg: "336px", xl: "418px" },
      borderRadius: "40px",
      mt: { md: "60px", lg: "80px", xl: "101px" },
      mr: { md: "20px", lg: "30px", xl: "50px" },
    },
    firstTitle: {
      color: mainColor,
      fontSize: { md: "19px", lg: "26px", xl: "30px" },
      lineHeight: { md: "25px", xl: "36px" },
      width: { md: "201px", lg: "266px", xl: "335px" },
      fontFamily: theme.typography.montserrat.bold,
      textAlign: { xs: "center" },
      mt: { md: "22px", lg: "30px", xl: "37.4px" },
    },
    firstSubtitle: {
      color: theme.palette.blue.light,
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: { md: "15px", lg: "20px", xl: "24px" },
      lineHeight: { md: "22px", lg: "28px", xl: "36px" },
      maxWidth: { md: "200px", lg: "229px", xl: "359px" },
      height: { xl: "108px" },
      mt: { md: "20.4px", lg: "27.4px", xl: "34px" },
      textAlign: { xs: "center" },
    },

    secondCard: {
      display: "flex",
      flexDirection: { xs: "column" },
      alignItems: { xs: "center" },
      background: theme.palette.white.main,
      height: { md: "300px", lg: "364px", xl: "454px" },
      width: { md: "270px", lg: "336px", xl: "418px" },
      borderRadius: "40px",
      mt: { md: "97px", lg: "130px", xl: "162px" },
      boxShadow: "0 10px 50px 0 rgba(0, 0, 0, 0.05)",
      mr: { md: "20px", lg: "30px", xl: "50px" },
    },

    secondTitle: {
      color: theme.palette.blue.main,
      fontSize: { md: "19px", lg: "26px", xl: "30px" },
      lineHeight: { md: "25px", xl: "36px" },
      maxWidth: { lg: "164px", xl: "206px" },

      fontFamily: theme.typography.montserrat.bold,
      textAlign: { xs: "center" },
      mt: { md: "22px", lg: "32px", xl: "38.4px" },
    },
    secondSubtitle: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: { md: "15px", lg: "20px", xl: "24px" },
      lineHeight: { md: "22px", lg: "28px", xl: "36px" },
      maxWidth: { md: "225px", lg: "288px", xl: "345px" },
      mt: { md: "12px", lg: "16px", xl: "27px" },
      textAlign: { xs: "center" },
    },
    thirdCard: {
      display: "flex",
      flexDirection: { xs: "column" },
      alignItems: { xs: "center" },
      background: theme.palette.white.main,
      height: { md: "300px", lg: "363px", xl: "454px" },
      width: { md: "270px", lg: "336px", xl: "418px" },
      borderRadius: "40px",
      mt: { md: "99px", lg: "132px", xl: "162px" },
      boxShadow: "0 10px 50px 0 rgba(0, 0, 0, 0.05)",
    },

    thirdTitle: {
      color: theme.palette.blue.main,
      fontSize: { md: "19px", lg: "26px", xl: "30px" },
      lineHeight: { md: "25px", xl: "36px" },
      width: { md: "201px", lg: "268px", xl: "337px" },

      fontFamily: theme.typography.montserrat.bold,
      textAlign: { xs: "center" },
      mt: { md: "22px", lg: "24px", xl: "30px" },
    },
    thirdSubtitle: {
      color: theme.palette.blue.main,
      fontFamily: theme.typography.anaHeim.regular,
      fontSize: { md: "15px", lg: "20px", xl: "24px" },
      lineHeight: { md: "22px", lg: "28px", xl: "36px" },
      width: { md: "240px", lg: "300px", xl: "375px" },
      mt: { md: "12px", lg: "16px", xl: "19px" },
      textAlign: { xs: "center" },
    },
  });

  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const componentName = "CardsBenefitsMobile";
  const translation = useTranslation(pathname, componentName);
  const { cards } = translation;

  return (
    <Box sx={classes.container}>
      <Box sx={classes.child}>
        {["second", "first", "third"].map((number, i) => (
          <Box sx={classes[`${number}Card`]} key={number}>
            {cards[i].img && (
              <img
                src={cards[i].img.src}
                alt={cards[i].img.alt}
                style={stylesHelper() && stylesHelper()[`${number}Img`]}
              />
            )}
            <Typography sx={classes[`${number}Title`]}>
              {cards[i].title}
            </Typography>
            <Typography sx={classes[`${number}Subtitle`]}>
              {cards[i].subtitle}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CardBenefitsDesktop;
